module.exports = __webpack_public_path__ + "static/media/zh-CN.e0c7dbd4.md";